import React from "react";

interface FeatureCardProps {
  card: {
    icon: React.ReactNode;
    title: string;
    description: string;
  };
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  isMobile?: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  card,
  style,
  onClick,
  className = "",
  isMobile = false,
}) => {
  return (
    <div
      className={`mt-3 mt-md-5 p-3 p-sm-4 position-absolute bg-dark rounded-4 shadow-lg d-flex flex-column justify-content-start align-items-center text-center transition ${className}`}
      style={{
        width: isMobile ? "85%" : "50%",
        maxWidth: isMobile ? "350px" : "600px",
        minHeight: isMobile ? "280px" : "300px",
        left: "50%",
        transform: "translateX(-50%)",
        ...style,
      }}
      onClick={onClick}
    >
      <div
        className={isMobile ? "mb-2" : "mb-3"}
        style={{ fontSize: isMobile ? "2rem" : "2.5rem" }}
      >
        {card.icon}
      </div>
      <h3 className={`text-white ${isMobile ? "fs-5" : "fs-4"} mb-2 mb-md-3`}>
        {card.title}
      </h3>
      <p
        className={`text-white ${isMobile ? "small" : ""} mb-0`}
        style={{ lineHeight: "1.5" }}
      >
        {card.description}
      </p>
    </div>
  );
};

export default FeatureCard;
